module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8BAMAAADI0sRBAAAAHlBMVEUAAAD//wD/1Q7/0wL/1QL/1QH/1QH/1AH/1AH/1AEXTf6vAAAACXRSTlMAARJvpNf1+fqjEOPsAAAASElEQVQ4y2MQMu2ciQpmBCsywIFK5Ux0MN0JIW0+ExMUI6QjsUhPRUhnYpGeRrRuAnYTcDkBf4+CYQZG0/loOh9N56PpnAYAAPRAPZ58zpgAAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic-menu-y.png
// module id = 640
// module chunks = 17